import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AlertifyService } from './alertify.service';
import { FarmerVM, OperationResult } from '../models/ViewModels';
import { environment } from '../../environments/environment';
import { ErrorService } from '../interceptors/error.service';

@Injectable({
  providedIn: 'root'
})
export class FarmerService {

  farmerApi = `${environment.apiUrl}/Farmer`;

  constructor(private http: HttpClient,
    private errorService: ErrorService,
    private alertify: AlertifyService) { }

  create(farmer: FarmerVM) {
    return this.http.post(this.farmerApi, farmer).pipe(
      map((response: OperationResult<FarmerVM>) => {
        if (response.Success) {
          this.alertify.success("Ganadero creado exitosamente.");
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  update(farmer: FarmerVM) {
    return this.http.put(this.farmerApi, farmer).pipe(
      map((response: OperationResult<FarmerVM>) => {
        if (response.Success) {
          this.alertify.success("Ganadero editado exitosamente.");
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  delete(id: string) {
    const uri = `${this.farmerApi}?uuid=${id}`;
    return this.http.delete(uri).pipe(
      map((response: OperationResult<boolean>) => {
        if (response.Success) {
          this.alertify.success("Ganadero eliminado exitosamente");
          return true;
        } else {
          this.errorService.logerrorMessage(response);
          return false;
        }
      }));
  }

  activate(farmer: FarmerVM) {
    const uri = `${this.farmerApi}/ActivateRecord`;
    return this.http.put(uri, farmer).pipe(
      map((response: OperationResult<boolean>) => {
        if (response.Success) {
          this.alertify.success("Ganadero activado exitosamente");
          return true;
        } else {
          this.errorService.logerrorMessage(response);
          return false;
        }
      }));
  }

  getAll() {
    return this.http.get(this.farmerApi).pipe(
      map((response: OperationResult<FarmerVM[]>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }



  getDeleted() {
    const uri = `${this.farmerApi}/GetDeleted`;;
    return this.http.get(uri).pipe(
      map((response: OperationResult<FarmerVM[]>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  getById(id: string) {
    const uri = `${this.farmerApi}/GetByIdentifier?uuid=${id}`;
    return this.http.get(uri).pipe(
      map((response: OperationResult<FarmerVM>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }
}
